import {
  isSelection,
  settingsKey
} from 'modules/candidate-profile/tables/filters/candidateFilterState';
import {
  CandidateFilterState,
  CandidateSelectionFilter
} from 'modules/candidate-profile/types/CandidateSearchFilter';

const sameSelection = (
  left: CandidateSelectionFilter,
  right: CandidateFilterState
): right is CandidateSelectionFilter =>
  isSelection(right) && left.field === right.field && left.mode === right.mode;

// The values the recruiter picked after the latest search: the reply did not
// see them, so the table no longer matches it.
export const getManualFilterConditions = (
  conditions: CandidateFilterState[],
  searchedConditions: CandidateFilterState[]
): CandidateFilterState[] =>
  conditions.flatMap((condition): CandidateFilterState[] => {
    // A Yes/No, a range or a radius is one setting: manual unless the search
    // ran it as it is.
    if (!isSelection(condition)) {
      const settings = settingsKey(condition);
      return searchedConditions.some((other) => settingsKey(other) === settings)
        ? []
        : [condition];
    }

    const searched = searchedConditions
      .filter((other) => sameSelection(condition, other))
      .flatMap((other) => other.values);
    const values = condition.values.filter(
      (value) => !searched.includes(value)
    );

    return values.length ? [{ ...condition, values }] : [];
  });
